import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SetStyles } from "../.././MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { SlideFactory } from "../Slider/SecondScreenHelp";

// namespace SlotGames2
// {
	export class BambooSecrets2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory: ISlideFactoryGeneric = new FactoryDoubleSlide();

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/go3v2.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	}

	class PandaSecondScreenHelpFactory extends SlideFactory
	{
		public override CreateStyle():Partial<CSSStyleDeclaration>
		{
			let style: Partial<CSSStyleDeclaration> = 
			{
				color:"White"
			};
			return style;
		}
	}

// }
